<div class="grid sm:grid-cols-4 gap-6 w-full max-w-200">
    <div class="sm:col-span-2">
        <div class="flex-auto cursor-pointer">
            <div class="leading-6 font-semibold">Wartość brutto w PLN</div>
            <div class="text-md text-secondary">Wyświetlaj przeliczoną wartość brutto w PLN na fakturach w walutach obcych</div>
        </div>
    </div>
    <div class="sm:col-span-2">
        <div class="flex items-center space-x-3">
            <mat-slide-toggle 
                color="primary"
                [checked]="showConvertedAmount"
                [disabled]="isProcessing"
                (change)="toggleShowConvertedAmount()">
            </mat-slide-toggle>
            <div class="text-sm text-gray-600 dark:text-gray-400">
                {{showConvertedAmount ? 'Włączone' : 'Wyłączone'}}
            </div>
        </div>
        
        <div class="mt-4 text-xs text-gray-500 dark:text-gray-400">
            <mat-icon class="icon-size-4 mr-1" [svgIcon]="'tabler_outline:info-circle'"></mat-icon>
            Po włączeniu, na wydruku faktury w walucie obcej pojawi się przeliczona wartość brutto w PLN (na podstawie podanego kursu wymiany).
        </div>
    </div>
</div>
